<template>
  <div class="ep-user__count">
    <signature v-for="(item, idx) in signatures" :key="idx" :profile="profile" :signature="signatures[idx]" :serial="idx + 1" @loading="onLoading"></signature>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import Loading from '@/components/Loading'
  import Signature from './Signature'

  export default {
    components: {
      Loading,
      Signature
    },

    props: {
      profile: Object,
      signatures: Array
    },

    methods: {
      onLoading(state) {
        this.loading = state;
      }
    }
  }
</script>

<style scoped>

</style>
